
/* IMPORTAÇÕES */

let date = new Date();
let v = date.getHours()+'-'+date.getMinutes()+'-'+date.getSeconds();

import Parallax from './components/Parallax.js';
import Templates from './components/Templates.js';
import SwiperPlugin from './components/SwiperPlugin.js';
import GaleriaCarrossel from './components/GaleriaCarrossel.js';
import CalculadoraDeep from './components/CalculadoraDeep.js';

/* INSTANCIA CLASSES */

const parallax          = new Parallax;
const templates         = new Templates;
const swiperplugin      = new SwiperPlugin;
const galeriacarrossel  = new GaleriaCarrossel;
const calculadoraDeep   = new CalculadoraDeep;

/* RUN EVENTOS HABILITANDO JQUERY */

$(function()
{
    parallax.init();
    templates.init();
    swiperplugin.init();
    galeriacarrossel.init();
    calculadoraDeep.init();

    window.addEventListener('load', function()
    {
        // $('.tabComponente').addClass('Opened');
        // $('.wrapCarrosselContainer').addClass('Opened');
    });
});